import { Market, PrivacySettingToggles } from '../types/market';
import { nz as adConfig } from '../ads';

const market: Market = {
  countryCode: 'nz',
  active: true,
  sitename: 'PriceSpy',
  permanentRedirect: true,
  redirectHosts: [
    'm.pricespy.co.nz',
    'www.pricespy.co.nz',
    'pricespy.nz',
    'www.pricespy.nz',
  ],
  superSearchEndpoint: 'https://search.pricespy.co.nz/rfe',
  classicProxy: {
    host: 'int-classic-nz.prisjakt.io',
    secure: true,
    port: 443,
  },
  useClassicUrls: true,
  hrefLang: ['en-NZ'],
  sites: {
    production: 'https://pricespy.co.nz',
    classic: 'https://classic.pricespy.co.nz',
    analytics: 'https://classic.pricespy.co.nz/analytics/store/',
    brands: undefined,
    forum: 'https://classic.pricespy.co.nz/forum',
    mobile: undefined,
  },
  api: {
    default: 'http://int-api-nz.prisjakt.io:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-production-qideuqilvm53zm5fl7rvnxxowu.ap-southeast-2.es.amazonaws.com',
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'en_NZ',
  timezone: 'Pacific/Auckland',
  currencyCode: 'NZD',
  url: {
    campaigns: '/theme',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.pricespy.co.nz',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/pricespy.co.nz/',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/PriceSpyNZ',
      clientID: '124411284258750',
      clientSecret: '34fa7d77a0a5b6af0859ec94cf7c9ad6',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      link: 'https://twitter.com/PriceSpyNZ',
      consumerKey: 'F4Kqw0BHbCkIhBwINKoXg',
      consumerSecret: '4nNxYvny4329u9qGt0ULm738Et43JwrlYPp6idUKU',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
  },
  email: {
    noreply: 'noreply@pricespy.co.nz',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    origin: 'http://int-cdn-origin.prisjakt.io:8080',
    images: 'https://cdn.pji.nu/images/',
  },
  routes: {
    giftGuide: {
      // HACK: Must include all current running giftGuides, hardcoded
      path: '/theme/:name(christmas-gift-ideas)/:list?',
    },
    themes: {
      path: '/theme',
    },
    campaign: {
      path: '/theme/:name',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Best smartphones',
      path: '?sort=product.user_reviews.rating%7Cdesc&category=103',
    },
    {
      title: 'Great deals on headphones',
      path: '?sort=rank%7Cdesc&category=148',
    },
    {
      title: 'Best deals kitchen and whiteware',
      path: '?sort=rank%7Cdesc&category=1671%7C504',
    },
    {
      title: 'Best deals under $100',
      path: '?price=1-100',
    },
  ],
  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: 'B7L94dEdgU9jQ',
    gansubFormId: 'O5VZ',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '3',
      cookieUrl: '/info/cookies--i7',
      privacyUrl: '/info/privacy-policy--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '3',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showClassicSwitch: true,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {
    isVotingOpen: false,
    year: 2018,
  },
};

export default market;
